export default __webpack_public_path__ + "static/media/Temple with cows.1d3fbef8.jpg";